<template>
  <div class="join">
    <div class="join-title">一匠正在寻找合作伙伴</div>
    <div class="partner-box">
      <div class="distribution">
        <img src="../../static/images/jingxiao.png" alt="" />
        <div class="public-left">
          <div class="public-title">经销合作伙伴</div>
          <div class="public-text">
            在某一区域，具备一定的营销能力和客户基础，以代理经销一匠产品的方式，为客户提供本地化服务。
          </div>
        </div>
      </div>
      <div class="distribution">
        <img src="../../static/images/jishu.png" alt="" />
        <div class="public-left">
          <div class="public-title">技术与实施伙伴</div>
          <div class="public-text">
            经认证某一区域及领域为终端客户提供交付实施服务。包括IT综合服务提供商、系统集成商、有实施能力的软件公司、院校伙伴等。
          </div>
        </div>
      </div>
      <div class="distribution">
        <img src="../../static/images/shengtai.png" alt="" />
        <div class="public-left">
          <div class="public-title">生态服务伙伴</div>
          <div class="public-text">
            致力于全方位构建一匠生态伙伴体系及架构，建立一批核心战略合作伙伴，满足电子商务全生命周期各阶段业务需求的伙伴供应，实现共赢。
          </div>
        </div>
      </div>
    </div>
    <!-- 经销商扶持计划 -->
    <div class="plan">
      <img src="../../static/images/bejing.png" alt="" class="bejing" />
      <div class="plan-title">经销商扶持计划</div>
      <div class="plan-choice">
        <img src="../../static/images/00.png" v-if="current==1" class="other" />
        <img src= '../../static/images/1 (1).png' v-if="current!=1" alt=""  class="other" @click="getCurrent(1)">
        <img src='../../static/images/2.png' v-if="current!=2" class="other" @click="getCurrent(2)"/>
        <img src='../../static/images/01.png'  v-if="current==2"  class="other">  
        <img
          src="../../static/images/3.png"
          alt=""
          class="other"
          @click="getCurrent(3)"
          v-if="current!=3"
        />
         <img
          src="../../static/images/02.png"
          alt=""
          class="other"
           v-if="current==3"
        />
        <img
          src="../../static/images/4.png"
          alt=""
          class="other"
          @click="getCurrent(4)"
              v-if="current!=4"
        />
         <img
          src="../../static/images/03.png"
          alt=""
          class="other"
          v-if="current==4"
        />
        <img
          src="../../static/images/5.png"
          alt=""
          class="other"
          @click="getCurrent(5)"
          v-if="current!=5"
        />
         <img
          src="../../static/images/04.png"
          alt=""
          class="other"
          v-if="current==5"
        />
        <img
          src="../../static/images/6.png"
          alt=""
          class="other"
          @click="getCurrent(6)"
          v-if="current!=6"
        />
        <img
          src="../../static/images/05.png"
          alt=""
          class="other"
          v-if="current==6"
        />
      </div>
      <div class="plan-box">
        <div class="plan-box-title" v-if="current==1">丰厚返利</div>
        <div class="plan-box-title" v-if="current==2">培训支持</div>
        <div class="plan-box-title" v-if="current==3">产品支持</div>
        <div class="plan-box-title" v-if="current==4">物料支持</div>
        <div class="plan-box-title" v-if="current==5">市场支持</div>
        <div class="plan-box-title" v-if="current==6">服务支持</div>
        <div class="plan-box-text"  v-if="current==1">
          高回报返利体系，高续费比例带来稳定营收，季/年度优秀经销商激励。
        </div>
        <div class="plan-box-text"  v-if="current==2">
文档培训、视频培训、直播培训、现场培训等多元化培训方式，帮助经销商对销售、客服、技术进行业务能力提高，迅速打造一支战斗力惊人的
        </div>
        <div class="plan-box-text"  v-if="current==3">
          提供完备的行业解决方案，针对用户需求和市场变化，不断丰富产品功能，升级更新，促进经销商销售工作。
        </div>
        <div class="plan-box-text"  v-if="current==4">
          总部将定期更新产品物料，包括产品手册、使用说明、三折页、传单、客户案例、介绍PPT等，便于经销商及时获取产品信息
        </div>
        <div class="plan-box-text"  v-if="current==5">
          展会、交流会、发布会等市场活动，总部给予专业市场支持，指派相关人员协助市场活动开展
        </div>
        <div class="plan-box-text"  v-if="current==6">
          专职渠道客服随时相应，7×12小时全方位辅助，提供专业、安全的支持，推动伙伴技术完善。
        </div>
        <img
          src="../../static/images/13.png"
          alt=""
          class="plan-box-img"
          v-if="current == 1"
        />
        <img
          src="../../static/images/14.png"
          alt=""
          class="plan-box-img"
          v-if="current == 2"
        />
        <img
          src="../../static/images/15.png"
          alt=""
          class="plan-box-img"
          v-if="current == 3"
        />
        <img
          src="../../static/images/16.png"
          alt=""
          class="plan-box-img"
          v-if="current == 4"
        />
        <img
          src="../../static/images/17.png"
          alt=""
          class="plan-box-img"
          v-if="current == 5"
        />
        <img
          src="../../static/images/18.png"
          alt=""
          class="plan-box-img"
          v-if="current == 6"
        />
      </div>
    </div>
    <!-- 合作条件 -->
    <div class="condition">
      <div class="condition-title">合作条件</div>
      <div class="condition-list">
        <img src="../../static/images/001.png" alt="" />
        <div class="list-right">
          <div class="list-title">认可一匠文化</div>
          <div class="list-text">认同一匠的价值及文化理念，愿意跟一匠长期发展</div>
        </div>
      </div>
      <div class="condition-list">
        <img src="../../static/images/002.png" alt="" />
        <div class="list-right">
          <div class="list-title">具有行业背景</div>
          <div class="list-text">有互联网及广告媒体背景，对saas行业有了解</div>
        </div>
      </div>
      <div class="condition-list">
        <img src="../../static/images/003.png" alt="" />
        <div class="list-right">
          <div class="list-title">具有团队管理经验</div>
          <div class="list-text">
            有专属且成熟的销售团队，负责人有团队管理经验
          </div>
        </div>
      </div>
      <div class="condition-list">
        <img src="../../static/images/004.png" alt="" />
        <div class="list-right">
          <div class="list-title">具有资源</div>
          <div class="list-text">拥有丰富的企业级资源</div>
        </div>
      </div>
    </div>
    <!-- 合作流程 -->
    <div class="technological-process">
 <img src="../../static/images/beijing (2).png" alt="" class="technological-process-bag">
<div class="technological-process-title">合作流程</div>
 <img src="../../static/images/liucheng.png" class="technological-process-img">
<div class="technological-process-box">
  <div class="process-box-tetx1">“成为合作伙伴”</div>
    <div class="process-box-tetx2">如有任何合作需求， 欢迎发送邮件至glb@wsandos.com，我们期待与您合作！</div>
      <div class="process-box-btn" @click="getShow">我要合作</div>
</div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      // 经销商扶持计划的切换
      current: 1,
    };
  },
  methods: {
    // 切换
    getCurrent(currentId) {
      this.current = currentId;
    },
    // 点击切换到信息填写的页面
    getShow(){
     this.$emit("changeJion",'1')
    },
  },
};
</script>
<style scoped>
.join-title {
  margin: 12.53% 0 6.53% 0;
  text-align: center;
  font-size: 0.38rem;
  font-weight: 800;
  color: #333333;
}
.partner-box {
  padding: 0 3.2%;
  margin-bottom: 12.66%;
}
.distribution {
  margin-top: 4%;
  display: flex;
  /* width: 93.6%; */
  height: 29.73%;
  padding: 5.33% 3.2%;
  background: #ffffff;
  box-shadow: 0px 0.05rem 0.17rem 0.03rem rgba(185, 185, 185, 0.15);
  border-radius: 0.08rem;
}
.distribution:first-child {
  margin: 0;
}
.distribution img {
  width: 12.3%;
  height: 10.66%;
}
.public-left {
  margin-left: 5.33%;
}
.public-title {
  font-size: 0.28rem;
  font-weight: bold;
  color: #333333;
}
.public-text {
  margin-top:2.66%;
  font-size: 0.24rem;
  line-height: 0.36rem;
  color: #666666;
}
.plan {
  position: relative;
}
.bejing {
  position: absolute;
  z-index: -1;
  left: 0;
  top: 0;
  width: 100%;
  /* height: 44.53%; */
}
.plan-title {
  font-size: 0.32rem;
  padding: 5.33% 0 0 0;
  text-align: center;
  font-weight: 800;
  color: #333333;
}
.plan-choice {
  padding: 0 5.33%;
  margin: 6.66% 0 4% 0;
}
.plan-choice img {
  margin-left: 6%;
}
.plan-choice img:first-child {
  margin: 0;
}
.plan-box {
  position: relative;
  margin: 0 auto;
  z-index: 1;
  padding-bottom: 11.2%;
  width:89.3%;
  height: 46.88%;
  background: #ffffff;
  box-shadow: 0px 0.03rem 0.15rem 0px rgba(111, 111, 111, 0.1);
  border-radius: 0.1rem;
}
.plan-box-text {
  text-align: left;
  font-size: 0.24rem;
  line-height: 0.36rem;
  padding: 0 6.4%;
  color: #666666;
}
.plan-box-title {
  text-align: center;
  padding: 6.4% 0 4% 0;
  font-size: 0.3rem;
  font-weight: bold;
  color: #333333;
}
.plan-box-img {
  position: absolute;
  right: 0;
  bottom: 0;
  z-index: -1;
  width: 31.06%;
  /* height: 19.73%; */
}
/* .select {
  width: 0.97rem;
  height: 0.97rem;
} */
.other {
  width: 10%;
  /* height: 9.06%; */
}
.condition {
  margin-top: 12.66%;
  padding-left: 3.2%;
}
.condition-title {
  text-align: center;
  font-size: 0.38rem;
  font-weight: 800;
  color: #333333;
}
.condition-list {
  margin-top:6.4%;
  display: flex;
}
.condition-list img {
  width: 6.4%;
  height: 6.4%;
}
.list-title {
  font-size: 0.28rem;
  font-weight: bold;
  color: #333333;
}
.list-text {
  margin-top: 3.06%;
  font-size: 0.24rem;
  color: #666666;
}
.list-right {
  margin-left: 2.8%;
}
.technological-process{
  position: relative;
  margin-top: 12.53%;
}
.technological-process-bag {
  position: absolute;
  left: 0;
  top: 0;
  z-index: -1;
  width: 100%;
  /* height: 6.5rem; */
}
.technological-process-title {
  text-align: center;
  padding-top: 6.66%;
font-size: 0.38rem;
font-weight: 800;
color: #FFFFFF;
}
.technological-process-img {
  width: 100%;
  /* height: 2.17rem; */
  margin: 6.53% 0  7.86% 0;

}
.technological-process-box {
  margin: 0 auto;
  text-align: center;
  padding: 6.66% 13.73%;
  width: 89.33%;
height: 45.6%;
background: #FFFFFF;
box-shadow: 0px 0.03rem 0.15rem 0px rgba(111, 111, 111, 0.1);
border-radius: 0.1rem;
}
.process-box-tetx1 {
font-size: 0.32rem;
font-weight: bold;
color: #333333;
}
.process-box-tetx2 {
  margin: 3.86% 0 6.66% 0;
font-size: 0.24rem;
font-weight: 400;
color: #333333;
}
.process-box-btn {
  width: 43.5%;
height: 30%;
margin: 0 auto;
line-height: 0.72rem;
text-align: center;
font-size: 0.28rem;
color: #333333;
background: #FFC000;
border-radius: 0.1rem;
}
</style>


// WEBPACK FOOTER //
// src/components/mobile/cooperationJoin.vue